import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';
import { messages } from './radiationTherapy.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class RadiationTherapyDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    const configuration = isNullOrWhiteSpace(this.props.radiationTherapy.configurationDisplay) ?
      this.props.radiationTherapy.configuration :
      this.props.radiationTherapy.configurationDisplay;
    const radiationType = isNullOrWhiteSpace(this.props.radiationTherapy.radiationTypeDisplay) ?
      this.props.radiationTherapy.radiationType :
      this.props.radiationTherapy.radiationTypeDisplay;
    const laterality = isNullOrWhiteSpace(this.props.radiationTherapy.lateralityDisplay) ?
      this.props.radiationTherapy.laterality :
      this.props.radiationTherapy.lateralityDisplay;

    return (
      this.props.radiationTherapy.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'radiationTherapy_' + this.props.radiationTherapy.site}>
        <div className="col-md-4 primary-data">
          {
            this.props.radiationTherapy.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.radiationTherapy.site}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.startDate} />}
                value={this.props.radiationTherapy.startDate} language={this.props.language} isDate
                isActive={this.configurationActive('StartDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.endDate} />}
                value={this.props.radiationTherapy.endDate} language={this.props.language} isDate
                isActive={this.configurationActive('EndDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.deliveredDose} />}
                value={this.props.radiationTherapy.displayDeliveredDose} language={this.props.language}
                isActive={this.configurationActive('DeliveredDose')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.deliveredFractions} />}
                value={this.props.radiationTherapy.deliveredFractions} language={this.props.language}
                isActive={this.configurationActive('DeliveredFractions')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.radiationType} />}
                value={radiationType} language={this.props.language}
                isActive={this.configurationActive('RadiationType')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.energyDisplay} />}
                value={this.props.radiationTherapy.energyDisplay} language={this.props.language}
                isActive={this.configurationActive('EnergyDisplay')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.provider} />}
                value={this.props.radiationTherapy.provider} language={this.props.language}
                isActive={this.configurationActive('Provider')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.radiationTherapy.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.radiationTherapy.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.radiationTherapy.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.elapsedDays} />}
                value={this.props.radiationTherapy.elapsedDays} language={this.props.language}
                isActive={this.configurationActive('ElapsedDays')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.laterality} />}
                value={laterality} language={this.props.language}
                isActive={this.configurationActive('Laterality')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.configuration} />}
                value={configuration} language={this.props.language}
                isActive={this.configurationActive('Configuration')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.radiationTherapy.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="radiationTherapy_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.radiationTherapy.nullMessage}
        </div>
      </div>
    );
  }
}

RadiationTherapyDetail.propTypes = {
  radiationTherapy: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
